export const useHotJar = () => {
  const userCentrics = useUserCentrics()
  const { appEnv } = useEnvs()

  const isLoaded = () => document.getElementById('HotjarScript') != null
  const isAllowedToLoad = computed(() => userCentrics.selectedPublishers.value.find(p => p.name === 'Hotjar'))

  const init = () => {
    if (isAllowedToLoad.value && appEnv.value === 'prod' && !isLoaded())
      import('./hotjar').then(({ initHotjar }) => initHotjar())
  }

  return { init }
}
